import { US_STATE_OPTIONS } from "@/features/practitioners/us-states";

export interface Option {
  value: string;
  label: string;
}

/** US state / territory options (reused from the practitioners feature). */
export const STATE_OPTIONS: Option[] = US_STATE_OPTIONS;

/** Preferred-contact options — legacy pref_phone set. */
export const PREF_CONTACT_OPTIONS: Option[] = [
  { value: "CELL", label: "Cell" },
  { value: "HOME", label: "Home" },
  { value: "WORK", label: "Work" },
  { value: "WORK_CELL", label: "Work Cell" },
  { value: "SPOUSE_HOME", label: "Spouse Home" },
  { value: "SPOUSE_CELL", label: "Spouse Cell" },
  { value: "SPOUSE_WORK", label: "Spouse Work" },
];

export const PASSPORT_OPTIONS: Option[] = [
  { value: "NO", label: "No" },
  { value: "YES", label: "Yes" },
  { value: "APPLYING", label: "Applying" },
];
